import React from 'react';
import TableRow from '@mui/material/TableRow';

function Fila(props) {
   const {registro, children, ...other} = props;
   return <TableRow {...other}>{children}</TableRow>;
}

export default Fila;
